import { render, staticRenderFns } from "./MediaGroupMediaEdit.vue?vue&type=template&id=3df081f5&"
import script from "./MediaGroupMediaEdit.vue?vue&type=script&lang=js&"
export * from "./MediaGroupMediaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports